import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from './components/ErrorFallback';
import 'antd/dist/antd.css';
import GlobalStyle from './GlobalStyle';
import './styles/common.css';
import Router from './routes';
import './lib/i18n';

const App: FC = () => {
  const history = useHistory();

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => history.push('/')}
    >
      <GlobalStyle />
      <Router />
    </ErrorBoundary>
  );
}

export default App;
